import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { AttributesetService } from 'src/app/services/attributeset.service';
import { LeadService } from 'src/app/services/lead.service';
import { FieldConfig } from '../../dynamic-form/field-interface';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { LeadStatusService } from 'src/app/services/lead-status.service';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { Router, NavigationEnd } from '@angular/router';
import { DealStatusService } from 'src/app/services/deal-status.service';
import { HrmDepartmentService } from 'src/app/services/hrm-department.service';
import { PosproductService } from 'src/app/services/posproduct.service';
import { UsersService } from 'src/app/services/users.service';
import { FloatLabelType } from '@angular/material/form-field';
import { CommonService } from 'src/app/services/common.service';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { RegisterService } from 'src/app/services/register.service';
const phoneUtil = PhoneNumberUtil.getInstance();
@Component({
  selector: 'calsoft-lead-dynamic-form',
  templateUrl: './lead-dynamic-form.component.html',
  styleUrls: ['./lead-dynamic-form.component.scss']
})
export class LeadDynamicFormComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';

  data: any;
  setId: any;
  leadId: any;
  isValidPhoneNumber: boolean = false;
  fullphone: string;
  leadCategoryOption: any;

  constructor(private attributeService: AttributesetService,
    private formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private datepipe: DatePipe,
    private leadStatusService: LeadStatusService,
      private registerService: RegisterService,
    private changeDetector: ChangeDetectorRef,
    private dynamicFormLabelService: DynamicFormLabelService,
    private leadSourceService: LeadSourceService,
    private leadService: LeadService,
    private dealStatusService: DealStatusService,
    private hrmDepartmentService: HrmDepartmentService,
    private router: Router,
    private usersService: UsersService,
    private posproductService: PosproductService,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<LeadDynamicFormComponent>,
    @Inject(MAT_DIALOG_DATA) data,) {

    this.data = data;
    this.setId = data['setId'];
    this.leadId = data['leadId'];
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });

  }

  formInit: boolean = false;
  filteredCountries: { id: string, name: string, flag: string, dial_code?: string }[] = [];


  ngOnInit(): void {

    this.formInit = false;
    this.createAttributeForm();
    this.getAttributeGroup();
    this.text = "Save";
    this.getLeadDropDownList();
    this.typeYFilter();
    this.getLeadSourceDownList();
    this.LeadSourceYFilter();
    this.getDealsStatusDownList();
    this.DealsStatusYFilter();
    this.getDepartmentDownList();
    this.DepartmentYFilter();
    this.getProductsDownList();
    this.ProductsYFilter();
    this.getUserDropDownList();
    this.usertypeYFilter();
    this.countrYFilter();
    this.getCountryList();
    this.searchControl.valueChanges.subscribe(value => {
      this.filterCountries(value);
    });
    this.originalCountries = this.originalCountries.map(c => {
      const parts = c.name.split('+');
      return {
        ...c,
        dial_code: parts.length > 1 ? `+${parts[1].trim()}` : ''
      };
    });
    // Initialize filteredCountries with the original list
    this.filteredCountries = this.originalCountries;

    this.searchControl.valueChanges.subscribe(value => {
      this.filterCountries(value);
    });

    
    let countryData = localStorage.getItem(Constant.COUNTRY_LOCATION);

    if (countryData == null || countryData == undefined) {
      this.getUserLocationData();
    } else {
      this.countryCode = JSON.parse(countryData);
      this.setCountryData()
    }
  
    const control = this.firstFormGroup.get('endTimeHour');
    if (control) {
      control.valueChanges.subscribe(value => {
        this.inputLength = value?.length;
     //   this.checkCondition();
      });
    }

  }
  inputLength: number = 0;

  text: any;
  textAdd: string;
  attributeSetIdList: Object;
  attributeGroup: any;
  leadAdd: any;
  regConfig: FieldConfig[]
  defalutValue: any = 0;
  groupName: any;
  newType: number = 1;
  patchValues: any;
  form: UntypedFormGroup;


  readonly hideRequiredControl = new FormControl(false);
  readonly floatLabelControl = new FormControl('individual' as FloatLabelType);

  selectedType1: string = 'individual';

  onSelectionChange(event: any) {
    this.selectedType1 = event.value;

  }
  originalCountries: { id: string, name: string, flag: string, dial_code?: string }[] = [
    {
      "id": "1",
      "name": "Afghanistan +93",
      "flag": "https://flagcdn.com/16x12/af.png"
    },
    {
      "id": "2",
      "name": "Albania +355",
      "flag": "https://flagcdn.com/16x12/al.png"
    },
    {
      "id": "3",
      "name": "Algeria +213",
      "flag": "https://flagcdn.com/16x12/dz.png"
    },
    {
      "id": "4",
      "name": "Andorra +376",
      "flag": "https://flagcdn.com/16x12/ad.png"
    },
    {
      "id": "5",
      "name": "Angola +244",
      "flag": "https://flagcdn.com/16x12/ao.png"
    },
    {
      "id": "6",
      "name": "Argentina +54",
      "flag": "https://flagcdn.com/16x12/ar.png"
    },
    {
      "id": "7",
      "name": "Armenia +374",
      "flag": "https://flagcdn.com/16x12/am.png"
    },
    {
      "id": "8",
      "name": "Australia +61",
      "flag": "https://flagcdn.com/16x12/au.png"
    },
    {
      "id": "9",
      "name": "Austria +43",
      "flag": "https://flagcdn.com/16x12/at.png"
    },
    {
      "id": "10",
      "name": "Azerbaijan +994",
      "flag": "https://flagcdn.com/16x12/az.png"
    },
    {
      "id": "11",
      "name": "Bahamas +1-242",
      "flag": "https://flagcdn.com/16x12/bs.png"
    },
    {
      "id": "12",
      "name": "Bahrain +973",
      "flag": "https://flagcdn.com/16x12/bh.png"
    },
    {
      "id": "13",
      "name": "Bangladesh +880",
      "flag": "https://flagcdn.com/16x12/bd.png"
    },
    {
      "id": "14",
      "name": "Barbados +1-246",
      "flag": "https://flagcdn.com/16x12/bb.png"
    },
    {
      "id": "15",
      "name": "Belarus +375",
      "flag": "https://flagcdn.com/16x12/by.png"
    },
    {
      "id": "16",
      "name": "Belgium +32",
      "flag": "https://flagcdn.com/16x12/be.png"
    },
    {
      "id": "17",
      "name": "Belize +501",
      "flag": "https://flagcdn.com/16x12/bz.png"
    },
    {
      "id": "18",
      "name": "Benin +229",
      "flag": "https://flagcdn.com/16x12/bj.png"
    },
    {
      "id": "19",
      "name": "Bhutan +975",
      "flag": "https://flagcdn.com/16x12/bt.png"
    },
    {
      "id": "20",
      "name": "Bolivia +591",
      "flag": "https://flagcdn.com/16x12/bo.png"
    },
    {
      "id": "21",
      "name": "Bosnia and Herzegovina +387",
      "flag": "https://flagcdn.com/16x12/ba.png"
    },
    {
      "id": "22",
      "name": "Botswana +267",
      "flag": "https://flagcdn.com/16x12/bw.png"
    },
    {
      "id": "23",
      "name": "Brazil +55",
      "flag": "https://flagcdn.com/16x12/br.png"
    },
    {
      "id": "24",
      "name": "Brunei +673",
      "flag": "https://flagcdn.com/16x12/bn.png"
    },
    {
      "id": "25",
      "name": "Bulgaria +359",
      "flag": "https://flagcdn.com/16x12/bg.png"
    },
    {
      "id": "26",
      "name": "Burkina Faso +226",
      "flag": "https://flagcdn.com/16x12/bf.png"
    },
    {
      "id": "27",
      "name": "Burundi +257",
      "flag": "https://flagcdn.com/16x12/bi.png"
    },
    {
      "id": "28",
      "name": "Cambodia +855",
      "flag": "https://flagcdn.com/16x12/kh.png"
    },
    {
      "id": "29",
      "name": "Cameroon +237",
      "flag": "https://flagcdn.com/16x12/cm.png"
    },
    {
      "id": "30",
      "name": "Canada +1",
      "flag": "https://flagcdn.com/16x12/ca.png"
    },
    {
      "id": "31",
      "name": "Cape Verde +238",
      "flag": "https://flagcdn.com/16x12/cv.png"
    },
    {
      "id": "32",
      "name": "Central African Republic +236",
      "flag": "https://flagcdn.com/16x12/cf.png"
    },
    {
      "id": "33",
      "name": "Chad +235",
      "flag": "https://flagcdn.com/16x12/td.png"
    },
    {
      "id": "34",
      "name": "Chile +56",
      "flag": "https://flagcdn.com/16x12/cl.png"
    },
    {
      "id": "35",
      "name": "China +86",
      "flag": "https://flagcdn.com/16x12/cn.png"
    },
    {
      "id": "36",
      "name": "Colombia +57",
      "flag": "https://flagcdn.com/16x12/co.png"
    },
    {
      "id": "37",
      "name": "Comoros +269",
      "flag": "https://flagcdn.com/16x12/km.png"
    },
    {
      "id": "38",
      "name": "Congo +242",
      "flag": "https://flagcdn.com/16x12/cg.png"
    },
    {
      "id": "39",
      "name": "Congo, Democratic Republic of the +243",
      "flag": "https://flagcdn.com/16x12/cd.png"
    },
    {
      "id": "40",
      "name": "Costa Rica +506",
      "flag": "https://flagcdn.com/16x12/cr.png"
    },
    {
      "id": "41",
      "name": "Croatia +385",
      "flag": "https://flagcdn.com/16x12/hr.png"
    },
    {
      "id": "42",
      "name": "Cuba +53",
      "flag": "https://flagcdn.com/16x12/cu.png"
    },
    {
      "id": "43",
      "name": "Cyprus +357",
      "flag": "https://flagcdn.com/16x12/cy.png"
    },
    {
      "id": "44",
      "name": "Czech Republic +420",
      "flag": "https://flagcdn.com/16x12/cz.png"
    },
    {
      "id": "45",
      "name": "Denmark +45",
      "flag": "https://flagcdn.com/16x12/dk.png"
    },
    {
      "id": "46",
      "name": "Djibouti +253",
      "flag": "https://flagcdn.com/16x12/dj.png"
    },
    {
      "id": "47",
      "name": "Dominica +1-767",
      "flag": "https://flagcdn.com/16x12/dm.png"
    },
    {
      "id": "48",
      "name": "Dominican Republic +1-809",
      "flag": "https://flagcdn.com/16x12/do.png"
    },
    {
      "id": "49",
      "name": "Ecuador +593",
      "flag": "https://flagcdn.com/16x12/ec.png"
    },
    {
      "id": "50",
      "name": "Egypt +20",
      "flag": "https://flagcdn.com/16x12/eg.png"
    },
    {
      "id": "51",
      "name": "El Salvador +503",
      "flag": "https://flagcdn.com/16x12/sv.png"
    },
    {
      "id": "52",
      "name": "Equatorial Guinea +240",
      "flag": "https://flagcdn.com/16x12/gq.png"
    },
    {
      "id": "53",
      "name": "Eritrea +291",
      "flag": "https://flagcdn.com/16x12/er.png"
    },
    {
      "id": "54",
      "name": "Estonia +372",
      "flag": "https://flagcdn.com/16x12/ee.png"
    },
    {
      "id": "55",
      "name": "Eswatini +268",
      "flag": "https://flagcdn.com/16x12/sz.png"
    },
    {
      "id": "56",
      "name": "Ethiopia +251",
      "flag": "https://flagcdn.com/16x12/et.png"
    },
    {
      "id": "57",
      "name": "Fiji +679",
      "flag": "https://flagcdn.com/16x12/fj.png"
    },
    {
      "id": "58",
      "name": "Finland +358",
      "flag": "https://flagcdn.com/16x12/fi.png"
    },
    {
      "id": "59",
      "name": "France +33",
      "flag": "https://flagcdn.com/16x12/fr.png"
    },
    {
      "id": "60",
      "name": "Gabon +241",
      "flag": "https://flagcdn.com/16x12/ga.png"
    },
    {
      "id": "61",
      "name": "Gambia +220",
      "flag": "https://flagcdn.com/16x12/gm.png"
    },
    {
      "id": "62",
      "name": "Georgia +995",
      "flag": "https://flagcdn.com/16x12/ge.png"
    },
    {
      "id": "63",
      "name": "Germany +49",
      "flag": "https://flagcdn.com/16x12/de.png"
    },
    {
      "id": "64",
      "name": "Ghana +233",
      "flag": "https://flagcdn.com/16x12/gh.png"
    },
    {
      "id": "65",
      "name": "Greece +30",
      "flag": "https://flagcdn.com/16x12/gr.png"
    },
    {
      "id": "66",
      "name": "Grenada +1-473",
      "flag": "https://flagcdn.com/16x12/gd.png"
    },
    {
      "id": "67",
      "name": "Guatemala +502",
      "flag": "https://flagcdn.com/16x12/gt.png"
    },
    {
      "id": "68",
      "name": "Guinea +224",
      "flag": "https://flagcdn.com/16x12/gn.png"
    },
    {
      "id": "69",
      "name": "Guinea-Bissau +245",
      "flag": "https://flagcdn.com/16x12/gw.png"
    },
    {
      "id": "70",
      "name": "Guyana +592",
      "flag": "https://flagcdn.com/16x12/gy.png"
    },
    {
      "id": "71",
      "name": "Haiti +509",
      "flag": "https://flagcdn.com/16x12/ht.png"
    },
    {
      "id": "72",
      "name": "Honduras +504",
      "flag": "https://flagcdn.com/16x12/hn.png"
    },
    {
      "id": "73",
      "name": "Hungary +36",
      "flag": "https://flagcdn.com/16x12/hu.png"
    },
    {
      "id": "74",
      "name": "Iceland +354",
      "flag": "https://flagcdn.com/16x12/is.png"
    },
    {
      "id": "75",
      "name": "India +91",
      "flag": "https://flagcdn.com/16x12/in.png"
    },
    {
      "id": "76",
      "name": "Indonesia +62",
      "flag": "https://flagcdn.com/16x12/id.png"
    },
    {
      "id": "77",
      "name": "Iran +98",
      "flag": "https://flagcdn.com/16x12/ir.png"
    },
    {
      "id": "78",
      "name": "Iraq +964",
      "flag": "https://flagcdn.com/16x12/iq.png"
    },
    {
      "id": "79",
      "name": "Ireland +353",
      "flag": "https://flagcdn.com/16x12/ie.png"
    },
    {
      "id": "80",
      "name": "Israel +972",
      "flag": "https://flagcdn.com/16x12/il.png"
    },
    {
      "id": "81",
      "name": "Italy +39",
      "flag": "https://flagcdn.com/16x12/it.png"
    },
    {
      "id": "82",
      "name": "Jamaica +1-876",
      "flag": "https://flagcdn.com/16x12/jm.png"
    },
    {
      "id": "83",
      "name": "Japan +81",
      "flag": "https://flagcdn.com/16x12/jp.png"
    },
    {
      "id": "84",
      "name": "Jordan +962",
      "flag": "https://flagcdn.com/16x12/jo.png"
    },
    {
      "id": "85",
      "name": "Kazakhstan +7",
      "flag": "https://flagcdn.com/16x12/kz.png"
    },
    {
      "id": "86",
      "name": "Kenya +254",
      "flag": "https://flagcdn.com/16x12/ke.png"
    },
    {
      "id": "87",
      "name": "Kiribati +686",
      "flag": "https://flagcdn.com/16x12/ki.png"
    },
    {
      "id": "88",
      "name": "Korea, North +850",
      "flag": "https://flagcdn.com/16x12/kp.png"
    },
    {
      "id": "89",
      "name": "Korea, South +82",
      "flag": "https://flagcdn.com/16x12/kr.png"
    },
    {
      "id": "90",
      "name": "Kuwait +965",
      "flag": "https://flagcdn.com/16x12/kw.png"
    },
    {
      "id": "91",
      "name": "Kyrgyzstan +996",
      "flag": "https://flagcdn.com/16x12/kg.png"
    },
    {
      "id": "92",
      "name": "Laos +856",
      "flag": "https://flagcdn.com/16x12/la.png"
    },
    {
      "id": "93",
      "name": "Latvia +371",
      "flag": "https://flagcdn.com/16x12/lv.png"
    },
    {
      "id": "94",
      "name": "Lebanon +961",
      "flag": "https://flagcdn.com/16x12/lb.png"
    },
    {
      "id": "95",
      "name": "Lesotho +266",
      "flag": "https://flagcdn.com/16x12/ls.png"
    },
    {
      "id": "96",
      "name": "Liberia +231",
      "flag": "https://flagcdn.com/16x12/lr.png"
    },
    {
      "id": "97",
      "name": "Libya +218",
      "flag": "https://flagcdn.com/16x12/ly.png"
    },
    {
      "id": "98",
      "name": "Liechtenstein +423",
      "flag": "https://flagcdn.com/16x12/li.png"
    },
    {
      "id": "99",
      "name": "Lithuania +370",
      "flag": "https://flagcdn.com/16x12/lt.png"
    },
    {
      "id": "100",
      "name": "Luxembourg +352",
      "flag": "https://flagcdn.com/16x12/lu.png"
    },
    {
      "id": "101",
      "name": "Madagascar +261",
      "flag": "https://flagcdn.com/16x12/mg.png"
    },
    {
      "id": "102",
      "name": "Malawi +265",
      "flag": "https://flagcdn.com/16x12/mw.png"
    },
    {
      "id": "103",
      "name": "Malaysia +60",
      "flag": "https://flagcdn.com/16x12/my.png"
    },
    {
      "id": "104",
      "name": "Maldives +960",
      "flag": "https://flagcdn.com/16x12/mv.png"
    },
    {
      "id": "105",
      "name": "Mali +223",
      "flag": "https://flagcdn.com/16x12/ml.png"
    },
    {
      "id": "106",
      "name": "Malta +356",
      "flag": "https://flagcdn.com/16x12/mt.png"
    },
    {
      "id": "107",
      "name": "Marshall Islands +692",
      "flag": "https://flagcdn.com/16x12/mh.png"
    },
    {
      "id": "108",
      "name": "Mauritania +222",
      "flag": "https://flagcdn.com/16x12/mr.png"
    },
    {
      "id": "109",
      "name": "Mauritius +230",
      "flag": "https://flagcdn.com/16x12/mu.png"
    },
    {
      "id": "110",
      "name": "Mexico +52",
      "flag": "https://flagcdn.com/16x12/mx.png"
    },
    {
      "id": "111",
      "name": "Micronesia +691",
      "flag": "https://flagcdn.com/16x12/fm.png"
    },
    {
      "id": "112",
      "name": "Moldova +373",
      "flag": "https://flagcdn.com/16x12/md.png"
    },
    {
      "id": "113",
      "name": "Monaco +377",
      "flag": "https://flagcdn.com/16x12/mc.png"
    },
    {
      "id": "114",
      "name": "Mongolia +976",
      "flag": "https://flagcdn.com/16x12/mn.png"
    },
    {
      "id": "115",
      "name": "Montenegro +382",
      "flag": "https://flagcdn.com/16x12/me.png"
    },
    {
      "id": "116",
      "name": "Morocco +212",
      "flag": "https://flagcdn.com/16x12/ma.png"
    },
    {
      "id": "117",
      "name": "Mozambique +258",
      "flag": "https://flagcdn.com/16x12/mz.png"
    },
    {
      "id": "118",
      "name": "Myanmar +95",
      "flag": "https://flagcdn.com/16x12/mm.png"
    },
    {
      "id": "119",
      "name": "Namibia +264",
      "flag": "https://flagcdn.com/16x12/na.png"
    },
    {
      "id": "120",
      "name": "Nauru +674",
      "flag": "https://flagcdn.com/16x12/nr.png"
    },
    {
      "id": "121",
      "name": "Nepal +977",
      "flag": "https://flagcdn.com/16x12/np.png"
    },
    {
      "id": "122",
      "name": "Netherlands +31",
      "flag": "https://flagcdn.com/16x12/nl.png"
    },
    {
      "id": "123",
      "name": "New Zealand +64",
      "flag": "https://flagcdn.com/16x12/nz.png"
    },
    {
      "id": "124",
      "name": "Nicaragua +505",
      "flag": "https://flagcdn.com/16x12/ni.png"
    },
    {
      "id": "125",
      "name": "Niger +227",
      "flag": "https://flagcdn.com/16x12/ne.png"
    },
    {
      "id": "126",
      "name": "Nigeria +234",
      "flag": "https://flagcdn.com/16x12/ng.png"
    },
    {
      "id": "127",
      "name": "North Macedonia +389",
      "flag": "https://flagcdn.com/16x12/mk.png"
    },
    {
      "id": "128",
      "name": "Norway +47",
      "flag": "https://flagcdn.com/16x12/no.png"
    },
    {
      "id": "129",
      "name": "Oman +968",
      "flag": "https://flagcdn.com/16x12/om.png"
    },
    {
      "id": "130",
      "name": "Pakistan +92",
      "flag": "https://flagcdn.com/16x12/pk.png"
    },
    {
      "id": "131",
      "name": "Palau +680",
      "flag": "https://flagcdn.com/16x12/pw.png"
    },
    {
      "id": "132",
      "name": "Panama +507",
      "flag": "https://flagcdn.com/16x12/pa.png"
    },
    {
      "id": "133",
      "name": "Papua New Guinea +675",
      "flag": "https://flagcdn.com/16x12/pg.png"
    },
    {
      "id": "134",
      "name": "Paraguay +595",
      "flag": "https://flagcdn.com/16x12/py.png"
    },
    {
      "id": "135",
      "name": "Peru +51",
      "flag": "https://flagcdn.com/16x12/pe.png"
    },
    {
      "id": "136",
      "name": "Philippines +63",
      "flag": "https://flagcdn.com/16x12/ph.png"
    },
    {
      "id": "137",
      "name": "Poland +48",
      "flag": "https://flagcdn.com/16x12/pl.png"
    },
    {
      "id": "138",
      "name": "Portugal +351",
      "flag": "https://flagcdn.com/16x12/pt.png"
    },
    {
      "id": "139",
      "name": "Qatar +974",
      "flag": "https://flagcdn.com/16x12/qa.png"
    },
    {
      "id": "140",
      "name": "Romania +40",
      "flag": "https://flagcdn.com/16x12/ro.png"
    },
    {
      "id": "141",
      "name": "Russia +7",
      "flag": "https://flagcdn.com/16x12/ru.png"
    },
    {
      "id": "142",
      "name": "Rwanda +250",
      "flag": "https://flagcdn.com/16x12/rw.png"
    },
    {
      "id": "143",
      "name": "Saint Kitts and Nevis +1-869",
      "flag": "https://flagcdn.com/16x12/kn.png"
    },
    {
      "id": "144",
      "name": "Saint Lucia +1-758",
      "flag": "https://flagcdn.com/16x12/lc.png"
    },
    {
      "id": "145",
      "name": "Saint Vincent and the Grenadines +1-784",
      "flag": "https://flagcdn.com/16x12/vc.png"
    },
    {
      "id": "146",
      "name": "Samoa +685",
      "flag": "https://flagcdn.com/16x12/ws.png"
    },
    {
      "id": "147",
      "name": "San Marino +378",
      "flag": "https://flagcdn.com/16x12/sm.png"
    },
    {
      "id": "148",
      "name": "Sao Tome and Principe +239",
      "flag": "https://flagcdn.com/16x12/st.png"
    },
    {
      "id": "149",
      "name": "Saudi Arabia +966",
      "flag": "https://flagcdn.com/16x12/sa.png"
    },
    {
      "id": "150",
      "name": "Senegal +221",
      "flag": "https://flagcdn.com/16x12/sn.png"
    },
    {
      "id": "151",
      "name": "Serbia +381",
      "flag": "https://flagcdn.com/16x12/rs.png"
    },
    {
      "id": "152",
      "name": "Seychelles +248",
      "flag": "https://flagcdn.com/16x12/sc.png"
    },
    {
      "id": "153",
      "name": "Sierra Leone +232",
      "flag": "https://flagcdn.com/16x12/sl.png"
    },
    {
      "id": "154",
      "name": "Singapore +65",
      "flag": "https://flagcdn.com/16x12/sg.png"
    },
    {
      "id": "155",
      "name": "Slovakia +421",
      "flag": "https://flagcdn.com/16x12/sk.png"
    },
    {
      "id": "156",
      "name": "Slovenia +386",
      "flag": "https://flagcdn.com/16x12/si.png"
    },
    {
      "id": "157",
      "name": "Solomon Islands +677",
      "flag": "https://flagcdn.com/16x12/sb.png"
    },
    {
      "id": "158",
      "name": "Somalia +252",
      "flag": "https://flagcdn.com/16x12/so.png"
    },
    {
      "id": "159",
      "name": "South Africa +27",
      "flag": "https://flagcdn.com/16x12/za.png"
    },
    {
      "id": "160",
      "name": "South Korea +82",
      "flag": "https://flagcdn.com/16x12/kr.png"
    },
    {
      "id": "161",
      "name": "South Sudan +211",
      "flag": "https://flagcdn.com/16x12/ss.png"
    },
    {
      "id": "162",
      "name": "Spain +34",
      "flag": "https://flagcdn.com/16x12/es.png"
    },
    {
      "id": "163",
      "name": "Sri Lanka +94",
      "flag": "https://flagcdn.com/16x12/lk.png"
    },
    {
      "id": "164",
      "name": "Sudan +249",
      "flag": "https://flagcdn.com/16x12/sd.png"
    },
    {
      "id": "165",
      "name": "Suriname +597",
      "flag": "https://flagcdn.com/16x12/sr.png"
    },
    {
      "id": "166",
      "name": "Sweden +46",
      "flag": "https://flagcdn.com/16x12/se.png"
    },
    {
      "id": "167",
      "name": "Switzerland +41",
      "flag": "https://flagcdn.com/16x12/ch.png"
    },
    {
      "id": "168",
      "name": "Syria +963",
      "flag": "https://flagcdn.com/16x12/sy.png"
    },
    {
      "id": "169",
      "name": "Taiwan +886",
      "flag": "https://flagcdn.com/16x12/tw.png"
    },
    {
      "id": "170",
      "name": "Tajikistan +992",
      "flag": "https://flagcdn.com/16x12/tj.png"
    },
    {
      "id": "171",
      "name": "Tanzania +255",
      "flag": "https://flagcdn.com/16x12/tz.png"
    },
    {
      "id": "172",
      "name": "Thailand +66",
      "flag": "https://flagcdn.com/16x12/th.png"
    },
    {
      "id": "173",
      "name": "Timor-Leste +670",
      "flag": "https://flagcdn.com/16x12/tl.png"
    },
    {
      "id": "174",
      "name": "Togo +228",
      "flag": "https://flagcdn.com/16x12/tg.png"
    },
    {
      "id": "175",
      "name": "Tonga +676",
      "flag": "https://flagcdn.com/16x12/to.png"
    },
    {
      "id": "176",
      "name": "Trinidad and Tobago +1-868",
      "flag": "https://flagcdn.com/16x12/tt.png"
    },
    {
      "id": "177",
      "name": "Tunisia +216",
      "flag": "https://flagcdn.com/16x12/tn.png"
    },
    {
      "id": "178",
      "name": "Turkey +90",
      "flag": "https://flagcdn.com/16x12/tr.png"
    },
    {
      "id": "179",
      "name": "Turkmenistan +993",
      "flag": "https://flagcdn.com/16x12/tm.png"
    },
    {
      "id": "180",
      "name": "Tuvalu +688",
      "flag": "https://flagcdn.com/16x12/tv.png"
    },
    {
      "id": "181",
      "name": "Uganda +256",
      "flag": "https://flagcdn.com/16x12/ug.png"
    },
    {
      "id": "182",
      "name": "Ukraine +380",
      "flag": "https://flagcdn.com/16x12/ua.png"
    },
    {
      "id": "183",
      "name": "United Arab Emirates +971",
      "flag": "https://flagcdn.com/16x12/ae.png"
    },
    {
      "id": "184",
      "name": "United Kingdom +44",
      "flag": "https://flagcdn.com/16x12/gb.png"
    },
    {
      "id": "185",
      "name": "United States +1",
      "flag": "https://flagcdn.com/16x12/us.png"
    },
    {
      "id": "186",
      "name": "Uruguay +598",
      "flag": "https://flagcdn.com/16x12/uy.png"
    },
    {
      "id": "187",
      "name": "Uzbekistan +998",
      "flag": "https://flagcdn.com/16x12/uz.png"
    },
    {
      "id": "188",
      "name": "Vanuatu +678",
      "flag": "https://flagcdn.com/16x12/vu.png"
    },
    {
      "id": "189",
      "name": "Vatican City +379",
      "flag": "https://flagcdn.com/16x12/va.png"
    },
    {
      "id": "190",
      "name": "Venezuela +58",
      "flag": "https://flagcdn.com/16x12/ve.png"
    },
    {
      "id": "191",
      "name": "Vietnam +84",
      "flag": "https://flagcdn.com/16x12/vn.png"
    },
    {
      "id": "192",
      "name": "Yemen +967",
      "flag": "https://flagcdn.com/16x12/ye.png"
    },
    {
      "id": "193",
      "name": "Zambia +260",
      "flag": "https://flagcdn.com/16x12/zm.png"
    },
    {
      "id": "194",
      "name": "Zimbabwe +263",
      "flag": "https://flagcdn.com/16x12/zw.png"
    }
  ]
  filterCountries(value: string): void {
    const filterValue = value.toLowerCase();
    if (!filterValue) {

      this.filteredCountries = this.originalCountries.slice();
    } else {
      this.filteredCountries = this.originalCountries.filter(country =>
        country.name.toLowerCase().includes(filterValue)
      );
    }
  }
  getAttributeGroup() {


    this.entityValue = {
      "typeId": this.firstFormGroup.value.type,
      "attributeSetId": this.setId,

    }
    this.attributeService.getattributeSetId(this.setId).subscribe(
      attributesets => {

        this.attributeSetIdList = attributesets['data']
        this.attributeGroup = attributesets['data']['eavAttributeGroup']
        this.leadAdd = true;
        this.regConfig = this.attributeSetIdList['eavAttributeGroup']
        this.groupName = this.regConfig[this.defalutValue]['attributeGroupName']
        this.form = this.createControl();
        this.form.addControl('endTimeHour', new FormControl('', Validators.required));


        console.log("demo Product", this.form);

        this.formInit = true;

        if (this.leadId > 0) {
          this.getLeadById(this.leadId);
        }

        this.textAdd = "Create";
      },
      error => {
        this.textAdd = "Create";
      }
    )


  }
  fieldValue: any[];

  invalidMap = new Map<any, any>();
  ValidMap = new Map<any, any>();
  validations: any = [];
  series: any = [];

  entityValue: any;

  attributeMap = new Map<any, any>();
  //create controls
  createControl() {

    this.formInit = true;
    let group;
    group = this.formBuilder.group({});
    this.entityValue = {
      "typeId": this.firstFormGroup.value.type,
      "attributeSetId": this.firstFormGroup.value.attributeSet,

    }

    let i = 0;
    this.regConfig.forEach(element => {


      if (element.attributeGroupId != 0) {




        element['eavEntityAttribute'].forEach(field => {

          this.attributeMap.set(field.eavAttribute.attributeCode, field.eavAttribute)

          if (field.eavAttribute.attributeCode == 'LeadCategory') {

            this.leadCategoryOption = field.eavAttribute.eavAttributeOption;

          }

          if (field.eavAttribute.attributeCode != "special_from_date"
            || field.eavAttribute.attributeCode != "special_to_date") {



            this.fieldValue = field;
            if (field.eavAttribute.frontendLabel != null &&
              field.eavAttribute.frontendLabel != undefined && field.eavAttribute.frontendInput != null) {

              if (field.eavAttribute['isVisible'] == 1) {
                field.eavAttribute['validations'] = [];
                let val = {
                  name: "required",
                  validator: Validators.required,
                  message: " Please fill out this field.",
                }
                const isEmailField = field.eavAttribute.frontendClass == 2 ||
                  field.eavAttribute.attributeCode?.toLowerCase() === 'email' ||
                  field.eavAttribute.attributeCode?.toLowerCase() === 'companies_email' ||
                  field.eavAttribute.frontendInput?.toLowerCase() === 'email' ||
                  (field.eavAttribute.frontendLabel && field.eavAttribute.frontendLabel.toLowerCase().includes('email'));

                if (field.eavAttribute.isRequired == 1 || isEmailField) {

                  if (this.invalidMap.get(i) == undefined) {
                    let val =
                      '(' + 'this.' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='INVALID'"

                    this.invalidMap.set(i, val);
                    this.ValidMap.set(i, val);
                  } else {
                    if (field.eavAttribute.attributeCode != null) {
                      let val = '||' + 'this.' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='INVALID'"

                      let inval = '&&' + 'form' + '.controls' + "['" + field.eavAttribute.attributeCode.toString() + "']" + '.status' + "=='VALID'"
                      this.invalidMap.set(i, this.invalidMap.get(i) + val);
                      this.ValidMap.set(i, this.ValidMap.get(i) + inval);
                    }
                  }
                  if (field.eavAttribute.isRequired == 1) {
                    field.eavAttribute['validations'].push(val);
                    this.validations.push(val);
                  }

                }
                if (isEmailField) {
                  let emailval = {
                    name: "pattern",
                    validator: Validators.pattern(
                      "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
                    ),
                    message: "Please enter a valid email address."
                  }
                  field.eavAttribute['validations'].push(emailval);
                  this.validations.push(emailval);
                }
                else if (field.eavAttribute.frontendClass == 1 || field.eavAttribute.frontendClass == 3) {
                  let numberval = {
                    name: "pattern",
                    validator: Validators.pattern(/^-?(0|[1-9]\d*)?$/),
                    message: "Only Numbers"
                  }
                  field.eavAttribute['validations'].push(numberval);
                  this.validations.push(numberval);
                }
                else if (field.eavAttribute.frontendClass == 5) {
                  let numberval = {
                    name: "pattern",
                    validator: Validators.pattern('^[a-zA-Z \-\']+'),
                    // validator: Validators.pattern('^[a-zA-Z][\sa-zA-Z]*'),
                    message: "Only  Alphabets"
                  }
                  field.eavAttribute['validations'].push(numberval);
                  this.validations.push(numberval);
                }
              }
              this.series.push({
                attributeId: field.eavAttribute.attributeId,
                entityTypeId: field.eavAttribute.entityTypeId,
                attributeCode: field.eavAttribute.attributeCode,
                backendType: field.eavAttribute.backendType,
                frontendInput: field.eavAttribute.frontendInput,
              })
              const control = this.formBuilder.control(
                field.eavAttribute.value,
                this.bindValidations(field.eavAttribute.validations || [])
              );
              group.addControl(field.eavAttribute.attributeCode, control);


              if (field.eavAttribute.backendType == 'int' && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
                group.controls[field.eavAttribute.attributeCode].setValue(parseInt(field.eavAttribute.defaultValue), { onlySelf: true });
              }
              else if ((field.eavAttribute.backendType == 'varchar' || field.eavAttribute.backendType == 'text') && field.eavAttribute.defaultValue != null && field.eavAttribute.defaultValue.length > 0) {
                group.controls[field.eavAttribute.attributeCode].setValue(field.eavAttribute.defaultValue, { onlySelf: true });
              }

            }
          }
        });
        if (this.invalidMap.get(i) != undefined) {
          let finaloutputInValid = this.invalidMap.get(i) + ')';
          this.invalidMap.set(i, finaloutputInValid);
          let finaloutputValid = this.ValidMap.get(i) + ')';
          this.ValidMap.set(i, finaloutputValid);
        }
        i++;
      }
    });


    return group;
  }


  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }


  //edit a Categor
  getLeadById(entityId: number) {
    this.leadService.getLeadById(entityId)
      .subscribe(
        (product: any) =>
          this.editProduct(product),



        (err: any) => { }
      );

  }

  listOfOptions: any = [];
  productData: any;

  emailValue: any;
  phoneValue: any;
  orginalData: any;
  valueId: any;
  editProduct(product: any) {
    this.productData = product;
    this.firstFormGroup.value.typeId = product.typeId;
    let products = product.values;
    this.phoneValue = product['values']['PhoneNumber'];
    this.emailValue = product['values']['Email'];
    this.orginalData = product['values']['originalData'];
    this.valueId = product.valueIds;
    this.series.forEach(element => {
      let attributeCode = element.attributeCode

      if (element.frontendInput == 'multiselect' && products[attributeCode] != null) {

        let listOfOptions: any = [];
        products[attributeCode].split(',').forEach(element => {
          listOfOptions.push(parseInt(element))
        });
        this.form.patchValue({
          [attributeCode]: listOfOptions
        });
      }
      else if (element.backendType == 'datetime') {
        if (products[attributeCode] != undefined && products[attributeCode] != null && products[attributeCode] !== '') {
          let str = (products[attributeCode] + '').trim();
          if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
            str += 'T00:00:00';
          } else if (/^\d{4}-\d{2}-\d{2}[ T]05:30:00(\.000)?$/.test(str)) {
            str = str.substring(0, 10) + 'T00:00:00';
          } else if (str.includes(' ') && !str.includes('T')) {
            str = str.replace(' ', 'T');
          }
          const d = new Date(str);
          this.form.patchValue({
            [attributeCode]: !isNaN(d.getTime()) ? d : products[attributeCode],
          });
        }
      } else {
        this.form.patchValue({
          [attributeCode]: products[attributeCode]
        });
      }
    });




  }
  firstFormGroup: UntypedFormGroup;
  sameLeadName: boolean;
  createAttributeForm() {
    this.firstFormGroup = this.formBuilder.group({
      attributeSet: ['', Validators.required],
      type: [''],
    });
  }




  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  submit() {

    console.log(this.form);

  }

  gender: any = [
    { "value": 0, "viewValue": "Male" },
    { "value": 1, "viewValue": "Female" },
  ]

  Priority: any = [
    { "value": 0, "viewValue": "High" },
    { "value": 1, "viewValue": "Medium" },
    { "value": 2, "viewValue": "Low" },
  ]


  isActive: any = [
    { "value": 0, "viewValue": "Active" },
    { "value": 1, "viewValue": "InActive" },

  ]

  State: any = [
    { "value": 0, "viewValue": "Andaman and Nicobar Islands" },
    { "value": 1, "viewValue": "Andhra Pradesh" },
    { "value": 2, "viewValue": "Arunachal Pradesh" },
    { "value": 3, "viewValue": "Assam" },
    { "value": 4, "viewValue": "Bihar" },
    { "value": 5, "viewValue": "Chandigarh" },
    { "value": 6, "viewValue": "Chhattisgarh" },
    { "value": 7, "viewValue": "Dadra and Nagar Haveli" },
    { "value": 8, "viewValue": "Daman and Diu" },
    { "value": 9, "viewValue": "Delhi" },
    { "value": 10, "viewValue": "Goa" },
    { "value": 11, "viewValue": "Gujarat" },
    { "value": 12, "viewValue": "Haryana" },
    { "value": 13, "viewValue": "Himachal Pradesh" },
    { "value": 14, "viewValue": "Jammu and Kashmir" },
    { "value": 15, "viewValue": "Jharkhand" },
    { "value": 16, "viewValue": "Karnataka" },
    { "value": 17, "viewValue": "Kerala" },
    { "value": 18, "viewValue": "Ladakh" },
    { "value": 19, "viewValue": "Lakshadweep" },
    { "value": 20, "viewValue": "Madhya Pradesh" },
    { "value": 21, "viewValue": "Maharashtra" },
    { "value": 22, "viewValue": "Manipur" },
    { "value": 23, "viewValue": "Meghalaya" },
    { "value": 24, "viewValue": "Mizoram" },
    { "value": 25, "viewValue": "Odisha" },
    { "value": 26, "viewValue": "Puducherry" },
    { "value": 27, "viewValue": "Punjab" },
    { "value": 28, "viewValue": "Rajasthan" },
    { "value": 29, "viewValue": "Sikkim" },
    { "value": 30, "viewValue": "Tamil Nadu" },
    { "value": 40, "viewValue": "Telangana" },
    { "value": 41, "viewValue": "Tripura" },
    { "value": 42, "viewValue": "Uttar Pradesh" },
    { "value": 43, "viewValue": "Uttarakhand" },
    { "value": 44, "viewValue": "West Bengal" },
  ]





  //leadStatus

  filtereddropdownTypeList: any;

  defaultLeadStatus: FormControl = new FormControl('');

  dropdownTypeList: any;
  dropdownList: any;
  protected _onDestroy = new Subject<void>();
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();


  getLeadDropDownList() {

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
      res => {
        this.dropdownList = res;
        this.dropdownTypeList = res;
        this.filtereddropdownTypeList = this.dropdownTypeList;
      },
      error => {
      })
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(status => status['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }

  createDynamicForm(event, formGroupId, statusId) {

    if (event.isUserInput != false) {

      this.patchValues.LeadStatus = statusId

      this.formInit = false;

      this.getFormArray(formGroupId)
    }

  }

  getFormArray(formGroupId) {

    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.regConfig = value;

        this.newType = 2;
        this.formInit = true;

        this.changeDetector.detectChanges();
      } else {
        console.log("No form fields found for this Form Group ID");
      }


    });
  }


  //leadSource

  filteredLeadSourceTypeList: any;

  LeadSourceTypeList: any;
  LeadSourceList: any;

  getLeadSourceDownList() {

    this.leadSourceService.getAllLeadSourceDropDown().subscribe(
      res => {
        this.LeadSourceList = res;
        this.LeadSourceTypeList = res;
        this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
      },
      error => {
      })
  }


  LeadSourceYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadSourceYFilter();
      });
  }


  protected typeLeadSourceYFilter() {
    if (!this.LeadSourceTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredLeadSourceTypeList = this.LeadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList.filter(source => source['sourceName'].toLowerCase().indexOf(search) > -1)
  }

  getAllSourcedropdowntype() {
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }



  //DealsStatus

  filteredDealsStatusTypeList: any;

  DealsStatusTypeList: any;
  DealsStatusList: any;

  getDealsStatusDownList() {

    this.dealStatusService.getAllDealStatusDropDown(1).subscribe(
      res => {
        this.DealsStatusList = res;
        this.DealsStatusTypeList = res;
        this.filteredDealsStatusTypeList = this.DealsStatusTypeList;
      },
      error => {
      })
  }


  DealsStatusYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeDealsStatusYFilter();
      });
  }


  protected typeDealsStatusYFilter() {
    if (!this.DealsStatusTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredDealsStatusTypeList = this.DealsStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredDealsStatusTypeList = this.DealsStatusTypeList.filter(source => source['DealStatus'].toLowerCase().indexOf(search) > -1)
  }

  getAllDealsStatusdropdowntype() {
    this.filteredDealsStatusTypeList = this.DealsStatusTypeList;
  }


  //Department

  filteredDepartmentTypeList: any;

  DepartmentTypeList: any;
  DepartmentList: any;

  getDepartmentDownList() {

    this.hrmDepartmentService.getAllhrmDepartmentDropDown(1).subscribe(
      res => {
        this.DepartmentList = res;
        this.DepartmentTypeList = res;
        this.filteredDepartmentTypeList = this.DepartmentTypeList;
      },
      error => {
      })
  }


  DepartmentYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeDepartmentYFilter();
      });
  }


  protected typeDepartmentYFilter() {
    if (!this.DepartmentTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredDepartmentTypeList = this.DepartmentTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredDepartmentTypeList = this.DepartmentTypeList.filter(departmentName => departmentName['departmentName'].toLowerCase().indexOf(search) > -1)
  }

  getAllDepartmentdropdowntype() {
    this.filteredDepartmentTypeList = this.DepartmentTypeList;
  }


  //ManageProducts

  filteredProductsTypeList: any;

  ProductsTypeList: any;
  ProductsList: any;

  getProductsDownList() {

    this.posproductService.getAllProductDropDown().subscribe(
      res => {
        this.ProductsList = res;
        this.ProductsTypeList = res;
        this.filteredProductsTypeList = this.ProductsTypeList;
      },
      error => {
      })
  }


  ProductsYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeProductsYFilter();
      });
  }


  protected typeProductsYFilter() {
    if (!this.ProductsTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredProductsTypeList = this.ProductsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredProductsTypeList = this.ProductsTypeList.filter(departmentName => departmentName['ProductIntrested'].toLowerCase().indexOf(search) > -1)
  }

  getAllProductsdropdowntype() {
    this.filteredProductsTypeList = this.ProductsTypeList;
  }


  //user Group

  defaultLeadOwner: FormControl = new FormControl('');

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;

  getUserDropDownList() {

    this.usersService.getAllUserStatusDropDown().subscribe(
      res => {
        this.userList = res;
        this.userTypeList = res;
        this.filtereduserTypeList = this.userTypeList;
      },
      error => {
      })
  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }


  saveLead() {

    if (this.form.valid && this.sameLeadName) {


      let leadEntity = {
        leadVarchar: [],
        leadInt: [],
        leadText: [],
        leadDecimal: [],
        leadDateTime: [],


      }

      for (let i = 0; i < this.series.length; i++) {

        this.series[i].value = this.form.value[this.series[i].attributeCode];
        if (this.leadId > 0) {
          this.series[i].entityId = this.leadId;
          this.series[i].valueId = parseInt(this.valueId[this.series[i].attributeCode]);
        }
        this.series[i].storeId = 1;
        if (this.series[i].backendType == "varchar" && this.series[i].value != null && this.series[i].frontendInput == "multiselect" && this.series[i]) {
          this.series[i].entityId = this.leadId;
          this.series[i].value = this.series[i].value.toString();
          leadEntity.leadVarchar.push(this.series[i])
        }
        else if (this.series[i].backendType == "varchar" && this.series[i]) {
          this.series[i].entityId = this.leadId;
          leadEntity.leadVarchar.push(this.series[i])
        } else if (this.series[i].backendType == "int") {
          this.series[i].entityId = this.leadId;
          leadEntity.leadInt.push(this.series[i]);
        }
        else if (this.series[i].backendType == "text") {
          this.series[i].entityId = this.leadId;
          leadEntity.leadText.push(this.series[i])
        } else if (this.series[i].backendType == "decimal") {

          if (this.series[i].value == null) {
            this.series[i].entityId = this.leadId;
            this.series[i].value = 0.0;
            this.series[i].value = parseFloat(this.series[i].value)
          }
          leadEntity.leadDecimal.push(this.series[i])
        }
        else if (this.series[i].backendType == "datetime") {
          if (this.series[i].value != null && this.series[i].value !== '') {
            this.series[i].entityId = this.leadId;
            let val = this.series[i].value;
            let d: Date = null;
            if (val instanceof Date) {
              d = new Date(val.getTime());
            } else if (typeof val === 'string') {
              let str = val.trim();
              if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
                str += 'T00:00:00';
              } else if (/^\d{4}-\d{2}-\d{2}[ T]05:30:00(\.000)?$/.test(str)) {
                str = str.substring(0, 10) + 'T00:00:00';
              } else if (str.includes(' ') && !str.includes('T')) {
                str = str.replace(' ', 'T');
              }
              d = new Date(str);
            } else {
              d = new Date(val);
            }
            if (d && !isNaN(d.getTime())) {
              if (d.getHours() === 5 && d.getMinutes() === 30 && d.getSeconds() === 0) {
                d.setHours(0, 0, 0, 0);
              }
              const formattedDate = this.datepipe.transform(d, "yyyy-MM-dd'T'HH:mm:ss");
              this.series[i].value = formattedDate;
            }
            leadEntity.leadDateTime.push(this.series[i]);
          }
        }

      }
      this.concatTelephoneWithEndTimeHour();

      leadEntity['operationType'] = this.leadId == 0 ? "NEW" : "CHANGE";
      leadEntity['entityTypeId'] = 9;
      leadEntity['attributeSetId'] = this.setId;
      leadEntity['typeId'] = this.leadId == 0 ? this.entityValue.typeId : this.firstFormGroup.value.typeId;
      leadEntity['hasOptions'] = 4;

      // console.log(this.form.value);

      leadEntity['leadSourceId'] = this.form.value.LeadSource;

      leadEntity['leadStatusId'] = this.form.value.LeadStatus;
      leadEntity['city'] = this.form.value.City;
      leadEntity['state'] = this.form.value.State;
      leadEntity['type'] = this.form.value.Type;
      leadEntity['country'] = this.form.value.Country;
      leadEntity['formId'] = this.form.value.FormId;

      leadEntity['PhoneNumber'] = this.form.value.PhoneNumber;

      leadEntity['email'] = this.form.value.Email;

      if (this.orginalData != undefined) {
        if (this.orginalData != null) {
          leadEntity['originalData'] = this.orginalData;
        }
      }

      if (this.leadId > 0) {
        leadEntity['entityId'] = this.leadId;

      }
      this.leadService.addlead(leadEntity).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.dialogRef.close({
              event: 'add',
            })

            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.text = "Save"
          }

          else {
            this.text = "Save"
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }

        },
        (err) => { this.text = "Save" });
    } else {
      this.text = "Save"
      this.validateAllFormFields(this.form);
    }
  }
  invalidNumber: boolean = false;
  MobmaxLength: any;
  countryCode: any;
  validationErr: boolean;
  errmsg(event) {
    const mobile = this.form.get('endTimeHour').value;
    const selectedCountry = this.form.get('PhoneNumber').value;

    let validationResult: any = null;

    switch (selectedCountry) {
      case '75': // India
        validationResult = this.validateIndianPhoneNumber(mobile);
        break;
      case '1': // Afghanistan
        validationResult = this.validate_PhoneNumber(mobile);
        break;
      default:
        validationResult = this.validate_PhoneNumber(mobile);
        break;
    }
    const endTimeHourControl = this.form.get('endTimeHour');

    // const teamControl = this.group.get(this.field.name);

    if (mobile.length !== this.MobmaxLength) {
      validationResult = true;
    }

    if (validationResult) {
      this.validationErr = true;

      this.form.get('endTimeHour').setErrors({ customError: true });
    } else {
      this.validationErr = false;
      // No validation error, proceed with form submission
      console.log('Valid number');
      this.form.get('endTimeHour').setErrors({ customError: false });
      console.log(this.form);

    }
  }
  changeValue(value: string, text: string) {

    const endTimeHourControl = this.form.get('endTimeHour');

    this.form.patchValue({ [value]: text });

    const index = this.originalCountries.findIndex(x => x.id === this.form.value.PhoneNumber);

    if (index > -1) {
      const url = this.originalCountries[index].flag;
      const match = url.match(/\/([a-z]{2})\.png$/);
      const countryCode = match ? match[1].toUpperCase() : null;

      try {

        // const number = this.phoneUtil.parse(text, countryCode);

        const number = phoneUtil.parse(text, countryCode);


        const isValid = phoneUtil.isValidNumberForRegion(number, countryCode);

        // Final validation check
        if (!isValid) {
          setTimeout(() => {
            this.form.get('endTimeHour').setErrors({ customError: 'Invalid phone number' });
            console.log("false");
          }, 500); // 500ms delay


        } else {
          setTimeout(() => {
            this.form.get('endTimeHour').setErrors(null);
            console.log("Phone number is valid (cleared after delay).");
            // console.log(teamControl);
          }, 500); // 500ms delay


          let sa = number.values_['1']
          let sa1 = text;
          console.log("the sa text is ", sa);
          console.log("the sa text is ", sa1);

          this.fullphone = sa + sa1;
          console.log("the FUllcountry code is ", this.fullphone);




          // this.firstFormGroup.get('PhoneNumber').setValue(sa + sa1);
        }
      } catch (error) {
        console.error("Error parsing phone number:", error);
        this.isValidPhoneNumber = false;
      }


    }


  }
  getCountryCode(value: string) {

    let index = this.originalCountries.findIndex(x => x.id == this.form.value.PhoneNumber);

    if (index > -1) {



      this.countryCode = this.extractCountryCode(this.originalCountries[index].name);


      return this.countryCode;




    }

  }
  extractCountryCode(text: string): string | null {
    const match = text.match(/\+\d+/);
    return match ? match[0] : null;
  }

  trimSpaces(controlName: string): void {
    const control = this.form.get(controlName);
    if (control) {
      const trimmedValue = control.value?.replace(/\s+/g, '') || ''; // Remove spaces
      control.setValue(trimmedValue, { emitEvent: false }); // Update control value
    }
  }
  validateIndianPhoneNumber(value: string) {
    const indianPhoneNumberPattern = /^[6789]\d{9}$/;
    if (!indianPhoneNumberPattern.test(value)) {
      return true;
    } else {
      return false;
    }
  }

  validate_PhoneNumber(value: string) {
    const indianPhoneNumberPattern = /^[1234567890]\d*$/;
    if (!indianPhoneNumberPattern.test(value)) {

      this.invalidNumber = true;

    } else {

      this.invalidNumber = false;
    }
  }
  concatTelephoneWithEndTimeHour() {
    const concatenated = this.fullphone;
    this.form.get('PhoneNumber')?.setValue(concatenated, { emitEvent: false });
  }
  checkLeadExist() {

    if ((this.emailValue != this.form.value.Email
      || this.phoneValue != this.form.value.PhoneNumber)) {
      let payload = {
        "Email": this.form.value.Email,
        "PhoneNumber": this.form.value.PhoneNumber,

      }

      console.log("payload", payload);

      this.leadService.leadAlreadyExist(payload).subscribe(
        (response) => {

          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.sameLeadName = true;
            this.saveLead();
          }
          else {
            this.text = "Save"
            this.snackBar.open(response['data']['message'], '×',
              { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => {
          this.text = "Save"
          this.sameLeadName = true
        });

      return this.sameLeadName;
    } else {

      this.saveLead()
    }

  }




  check() {
    if (this.leadId != 0) {

      if (this.firstFormGroup.value.attributeSet == null || this.firstFormGroup.value.attributeSet) {

        this.firstFormGroup.value.attributeSet = this.setId;

      }

      this.firstFormGroup.value.operationType = "Change"
    }
    else {
      this.firstFormGroup.value.operationType = "New"
    }
    if (this.form.valid) {

      if (this.leadId == 0) {
        this.checkLeadExist();
        this.sameLeadName = false;
      }
      // this.phoneValue = product['values']['PhoneNumber'];
      // this.emailValue = product['values']['Email'];
      else if (this.leadId > 0 && (this.emailValue != this.form.value.Email
        || this.phoneValue != this.form.value.PhoneNumber)) {
        this.checkLeadExist();
        this.sameLeadName = false;
      }
      else {
        this.sameLeadName = true;
        this.saveLead();
      }

    }


  }
  save() {

    this.text = "Processing"
    if (this.leadId != 0) {
      this.firstFormGroup.value.operationType = "Change"
    }
    else {
      this.firstFormGroup.value.operationType = "New"
    }
    if (this.form.valid) {
      this.sameLeadName = true
      this.concatTelephoneWithEndTimeHour();
      this.check()

    } else {
      this.text = "Save"
      this.validateAllFormFields(this.form);
    }
  }

  showTextField = false;

  moreInformation() {
    this.showTextField = !this.showTextField;

  }


  //country
  countryList: any;
  countryTypeList: any = [];
  filteredcountryTypeList: any = [];
  countryControl: UntypedFormControl = new UntypedFormControl();
  countryFilterControl: UntypedFormControl = new UntypedFormControl();
  options: any;


  getCountryList() {
    this.commonService.getCountryList().subscribe(
      data => {
        this.countryList = data;
        this.countryTypeList = data;
        this.filteredcountryTypeList = this.countryTypeList;

      }
    )
  }

  getAllCountry() {
    this.filteredcountryTypeList = this.countryTypeList;
  }

  countrYFilter() {
    this.countryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.countryFilter();
      });
  }
  searchControl = new FormControl();
  onSelectionChangeTwo(event: any) {
    const selectedValue = event.value;

    this.form.get('endTimeHour').reset();
    this.form.get('endTimeHour').setValidators([Validators.required]);
    this.form.get('endTimeHour').updateValueAndValidity();

  }
  protected countryFilter() {
    if (!this.countryTypeList) {
      return;
    }
    // get the search keyword
    let search = this.countryFilterControl.value;
    if (!search) {
      this.filteredcountryTypeList = this.countryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredcountryTypeList = this.countryTypeList.filter(country => country['countryName'].toLowerCase().indexOf(search) > -1)
  }
  preventMatSelectOpen(event: Event) {
    // event.stopPropagation();
  }
  
  getUserLocationData() {

    this.countryCode = this.registerService.getCountryCode()
    if (this.countryCode != undefined) {
      this.setCountryData()
    }

  }


  setCountryData() {

    //India +91

    let country = this.countryCode['country_name']
    let code = this.countryCode['country_calling_code']

    let value = country + " " + code;

    const recursiveIndex = this.originalCountries.findIndex(recursiveItem => recursiveItem.name == value);

    if (recursiveIndex !== -1) {



      this.form.get("PhoneNumber").setValue(this.originalCountries[recursiveIndex].id);

      this.form?.get("flag").setValue(this.originalCountries[recursiveIndex].flag);



    } else {
      this.form.get("PhoneNumber").setValue("75");

      this.form?.get("flag").setValue("https://flagcdn.com/16x12/in.png");

    }

  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
